/**
 * @file productsDetails
 * @author Wence
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TopBar from '../../components/TopBar';
import {connect} from 'react-redux';
import ListPro from '../../components/ListPro';
import Spin from '../../components/Spin';
import Loading from '../../components/Loading';
import confirmation from '../../components/Confirmation';

import {fetchProductDetailIndexData, fetchProductDetailList} from '../../actions/productDetailAction';
import './index.less';

class ProductsDetails extends PureComponent {
    static propTypes = {
        match: PropTypes.object,
        cmsapiProductDetailIndexData: PropTypes.object,
        fetchProductDetailIndexData: PropTypes.func,
        fetchProductDetailList: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            tagid: 0,
            isTabFixed: false,
            isLoading: false,
            isMore: false
        };
        this.onDocumentScroll = this.onDocumentScroll.bind(this);
        this.renderTabBar = this.renderTabBar.bind(this);
        this.renderList = this.renderList.bind(this);
        this.getArticleList = this.getArticleList.bind(this);
        this.getIsMore = this.getIsMore.bind(this);
        this.getProductDetailId = this.getProductDetailId.bind(this);
        this.getInitialTagId = this.getInitialTagId.bind(this);
        this.fetchMoreProductList = this.fetchMoreProductList.bind(this);
        this.openConfirm = this.openConfirm.bind(this);
        this.pushApplyPage = this.pushApplyPage.bind(this);
    }

    componentWillMount() {
        if (this.isPC()) {
            const id = this.props.match.params.id;
            location.href = `/productDetail/${id}`;
        }
    }

    componentDidMount() {
        const id = this.getProductDetailId();
        if (id) {
            this.props.fetchProductDetailIndexData({id}).then(() => {
                this.setState({isMore: this.getIsMore(), tagid: this.getInitialTagId()});
            });
        }

        document.addEventListener('scroll', this.onDocumentScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.onDocumentScroll);
    }

    getInitialTagId() {
        const cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;
        const tagsList = cmsapiProductDetailIndexData
            && cmsapiProductDetailIndexData.itemlist
            && cmsapiProductDetailIndexData.itemlist.tags;

        if (tagsList && tagsList.length === 1) {
            return tagsList[0] && tagsList[0].tagid;
        }

        return 0;
    }

    getScrollTop(e) {
        const ele = e ? e.target : document;
        return ele.documentElement.scrollTop || ele.body.scrollTop;
    }

    getArticleList() {
        const itemlist = this.props.cmsapiProductDetailIndexData.itemlist;

        return itemlist && itemlist.article_list;
    }

    getIsMore() {
        const updateArticleList = this.getArticleList();
        return updateArticleList && updateArticleList.cur_page < updateArticleList.total_page;
    }

    getProductDetailId() {
        return this.props.match.params.id;
    }

    onDocumentScroll(e) {
        const scrollTop = this.getScrollTop(e);
        if (this.tabNode.offsetTop <= scrollTop + this.topBox.clientHeight) {
            this.setState({isTabFixed: true});
        }
        else if (this.tabNode.offsetTop > scrollTop + this.topBox.clientHeight) {
            this.setState({isTabFixed: false});
        }
    }

    async changeTab(id) {
        this.setState({
            isLoading: true,
            tagid: id
        });

        if (this.state.isTabFixed) {
            document.documentElement.scrollTop
                = document.body.scrollTop
                = this.tabNode.offsetTop - this.tabNode.offsetHeight;
        }
        await this.props.fetchProductDetailList({id: this.getProductDetailId(), tagid: id, page: 1});

        this.setState({isLoading: false, isMore: this.getIsMore()});

        if (this.getScrollTop() < this.tabNode.offsetTop - this.tabNode.clientHeight) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        }
    }

    async fetchMoreProductList() {
        const articleList = this.getArticleList();
        const page = articleList ? articleList.cur_page + 1 : 1;
        this.setState({isMore: false});

        await this.props.fetchProductDetailList(
            {
                id: this.getProductDetailId(),
                tagid: this.state.tagid,
                page
            },
            true
        );
        this.setState({isMore: this.getIsMore()}, () => !this.state.isMore && this.forceUpdate());
    }

    openConfirm(content = '') {
        const isEmail = content.indexOf('@') >= 0;
        const href = isEmail ? `mailto:${content}` : `tel:${content}`;
        confirmation({
            content: `联系商务：${content}`,
            onOk: () => location.href = href
        });
    }

    pushApplyPage() {
        const id = this.getProductDetailId();
        const itemlist = this.props.cmsapiProductDetailIndexData.itemlist;
        if (itemlist.next_index === '2') {
            location.href = itemlist.next_url;
        } else {
            location.href = '/m/apply/' + id;
        }
    }

    renderTabBar() {
        const cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;
        const itemlist = cmsapiProductDetailIndexData.itemlist;
        const tabList = itemlist.tags;

        return (
            <div className="tab-warpper" ref={tabNode => this.tabNode = tabNode}>
                <div className={classnames('tab', {fixed: this.state.isTabFixed})}>
                    {tabList
                    && tabList.length > 3
                    && <div className="tab-shadow">
                        <div className="tab-shadow-left"></div>
                        <div className="tab-shadow-right"></div>
                    </div>
                    }
                    <div className="tab-content">
                        <ul>
                            {
                                tabList
                                && tabList.length > 1
                                && <li
                                    onClick={this.changeTab.bind(this, 0)}
                                    className={classnames({active: this.state.tagid === 0})}>
                                    全部
                                </li>
                            }
                            {tabList && tabList.map(tabItem => (
                                <li
                                    className={classnames({active: tabItem.tagid === this.state.tagid})}
                                    onClick={this.changeTab.bind(this, tabItem && tabItem.tagid)}
                                    key={tabItem && tabItem.tagid}>
                                    {tabItem && tabItem.tagname}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="border-bottom"></div>
                </div>
            </div>
        );
    }

    renderList() {
        const cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;
        const itemlist = cmsapiProductDetailIndexData.itemlist;
        const articleList = itemlist.article_list;
        if (this.state.isLoading) {
            // loading加载时默认为20个listpro高度防止闪动
            const defaultHeight = `${3.12 * 20}rem`;
            return <div
                key="list"
                className="list-loading"
                style={{height: defaultHeight}}>
                <Spin/>
            </div>;
        }

        return (
            [<div ref={listNode => this.listNode = listNode} key="list" className="section list">
                {articleList && articleList.datalist && articleList.datalist.map(listItem => (
                    <a
                        key={listItem.aid}
                        href={`/m/forum/page/${listItem.aid}`}
                        target="_blank">
                        <ListPro
                            title={listItem.title}
                            time={listItem.publish_time.slice(5, 10)}
                            brief={`${listItem.pv}人阅读`}
                            imgSrc={listItem.pic}/>
                    </a>
                ))}
            </div>, <Loading
                key="loading"
                style={{paddingTop: '1.25rem', paddingBottom: '1.05rem'}}
                isLoad={this.state.isMore}
                type={this.getIsMore()}
                callbackFn={this.fetchMoreProductList}/>
            ]
        );
    }

    renderProductCard() {
        const cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;
        const itemlist = cmsapiProductDetailIndexData.itemlist;

        return (
            <div key="product-center" className="product-center">
                <div className="product-center-content">
                    <span className="icon">
                        <img
                            src={itemlist && itemlist.segment_icon}
                            alt="icon"/>
                    </span>
                    {itemlist && itemlist.navigation_name}
                </div>
                <div className="product-center-footer">
                    <div className="btn" onClick={this.pushApplyPage}>
                        <span className="icon">
                            <img src={require('../../asset/svg/icon_try.svg')} alt="try"/>
                        </span>
                        {itemlist && itemlist.next_index_note}
                    </div>
                    {itemlist && itemlist.segment_contact && (
                        <div
                            onClick={this.openConfirm.bind(this, itemlist.segment_contact)}
                            className="btn border-left"
                        >
                            <span className="icon">
                                <img src={require('../../asset/svg/icon_business.svg')} alt="business"/>
                            </span>
                            商务合作
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;
        const isRender = cmsapiProductDetailIndexData && cmsapiProductDetailIndexData.itemlist;

        return (
            <div className="product-details">
                {!this.isPC()
                && <div className="top-bar-box" ref={topBox => this.topBox = topBox}>
                    <TopBar/>
                </div>
                }

                {isRender && this.renderProductCard()}
                {isRender && this.renderTabBar()}
                {isRender && this.renderList()}
            </div>
        );
    }
}

export default connect(
    state => ({cmsapiProductDetailIndexData: state.cmsapiProductDetailIndexData}),
    dispatch => ({
        fetchProductDetailIndexData: (...args) => dispatch(fetchProductDetailIndexData(...args)),
        fetchProductDetailList: (...args) => dispatch(fetchProductDetailList(...args))
    })
)(ProductsDetails);



// WEBPACK FOOTER //
// ./src/containers/productDetails/index.js